
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire36cd"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire36cd"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aotbN", function(module, exports) {

$parcel$export(module.exports, "addMessage", () => $7912c9a20126f7ce$export$16fdb433d434f08);

var $2yCyx = parcelRequire("2yCyx");
function $7912c9a20126f7ce$var$addCloseListener($notification) {
    const $delete = $notification.querySelector(".delete");
    if ($delete) $delete.addEventListener("click", ()=>{
        $7912c9a20126f7ce$var$removeMessage($notification);
    });
    if ($notification.classList.contains("is-success")) setTimeout(function() {
        // check opacity: message might be deleted by user within timeout
        if (!$notification.style.opacity || $notification.style.opacity === 1) $7912c9a20126f7ce$var$removeMessage($notification);
    }, (0, $2yCyx.$global_message_timeout) * 1000);
}
function $7912c9a20126f7ce$var$removeMessage($notification) {
    const fadeOutEffect = setInterval(function() {
        if (!$notification.style.opacity) $notification.style.opacity = 1;
        if ($notification.style.opacity > 0) $notification.style.opacity -= 0.1;
        else {
            clearInterval(fadeOutEffect);
            $notification.parentNode.removeChild($notification);
        }
    }, 50);
}
function $7912c9a20126f7ce$export$16fdb433d434f08(message, type) {
    const messageWrapper = document.createElement("div");
    messageWrapper.classList.add("notification", "has-text-centered", `is-${type}`);
    messageWrapper.innerText = message;
    const deleteButton = document.createElement("button");
    deleteButton.classList.add("delete");
    messageWrapper.prepend(deleteButton);
    document.querySelector("#messages").appendChild(messageWrapper);
    $7912c9a20126f7ce$var$addCloseListener(messageWrapper);
}
document.addEventListener("DOMContentLoaded", ()=>{
    (document.querySelectorAll(".notification") || []).forEach(($notification)=>{
        $7912c9a20126f7ce$var$addCloseListener($notification);
        // Message API: remove message
        try {
            fetch("/api/messages/delete", {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json"
                },
                body: `{"messageId":"${$notification.getAttribute("id")}"}`
            });
        } catch (error) {
            console.error(error.message);
        }
    });
});

});
parcelRegister("2yCyx", function(module, exports) {

$parcel$export(module.exports, "$global_message_timeout", () => $1dccaa342017d6cf$export$8cc1d7788ecc87b1);
// GLOBAL VARIABLES
// MESSAGE TIMEOUT
// Timeout when a message will disappear. Error messages have not applied the timeout and need to be cleared be the user.
var $1dccaa342017d6cf$export$8cc1d7788ecc87b1 = 5; // [in Seconds]

});



parcelRequire("aotbN");

//# sourceMappingURL=messages.js.map
